import { LOGISTIC_SEARCH_TERM, SET_LOGISTIC_GROUPS } from "../actions/logosticFilterActions";

const initialState = {
  searchTerm: null,
  logisticGroupsFilter: [],
};

const logosticFilterReduser = (state = initialState, action) => {
  switch (action.type) {
    case LOGISTIC_SEARCH_TERM: {
      return Object.assign({}, state, {
        searchTerm: action.data,
      });
    }

    case SET_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticGroupsFilter: action.data,
      });
    }

    default:
      return state;
  }
};

export default logosticFilterReduser;
